import React, { useState } from 'react';
import { ConfigProvider, theme } from 'antd';
import { ThemeProvider } from 'styled-components';
import themeConfig from './theme/themeConfig';
import ExcelMerger from './components/ExcelMerger';
import Layout from './components/Layout';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <ConfigProvider
      theme={{
        ...themeConfig,
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}
    >
      <ThemeProvider theme={{ isDarkMode }}>
        <Layout isDarkMode={isDarkMode} onThemeChange={setIsDarkMode}>
          <ExcelMerger />
        </Layout>
      </ThemeProvider>
    </ConfigProvider>
  );
}

export default App;
